import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useSendPerformancePedagogicalConfirmMutation } from 'api/tunnelSteps';
import { userSelectors } from 'reducers';
import { getSubscriptionRoleName, isStatusOk } from 'utils/helpers';
import { fundTypes, PM_DOCUMENTS_LIST, PP_DOCUMENTS_LIST, RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { Typography } from '@mui/material';
import { SubmitButton } from 'components';
import TunnelBox from '../common/TunnelBox';
import TunnelStep from '../common/TunnelStep';

const PerformancePedagogicStep = ({ handleNextStep, userStep }) => {
    const subscription = useSelector(userSelectors.getTunnelSubscription);
    const [sendPerformancePedagogicalConfirm, { isLoading: submitLoader }] =
        useSendPerformancePedagogicalConfirmMutation();
    const fundName = useMemo(() => subscription?.investmentFund?.name || '-', [subscription]);
    const sgpName = useMemo(() => subscription?.investmentFund?.sgp?.name || '-', [subscription]);
    const isResubmit = useMemo(() => userStep?.successfulAttemptsNumber > 0, [userStep]);
    const hasStatusOk = useMemo(() => isStatusOk(userStep), [userStep]);
    const isSLP = subscription?.investmentFund?.type === fundTypes.SLP;

    const handleSubmit = useCallback(() => {
        sendPerformancePedagogicalConfirm({
            callback: () => handleNextStep(true),
        });
    }, [sendPerformancePedagogicalConfirm, handleNextStep]);

    const renderDocument = (docName, index) => (
        <li key={index}>
            <Typography gutterBottom>{docName}</Typography>
        </li>
    );

    return (
        <TunnelStep title={texts.PERFORMANCE} maxWidth={950}>
            <TunnelBox>
                <Typography gutterBottom>
                    {isSLP
                        ? texts.PROCESSUS_DE_SOUSCRIPTION_SLP(fundName, sgpName)
                        : texts.PROCESSUS_DE_SOUSCRIPTION(fundName, sgpName)}
                </Typography>
                <br></br>
                <Typography gutterBottom>{texts.PORTEZ_A_NOTRE(sgpName)}</Typography>
                <br></br>
                <Typography gutterBottom>{texts.AFIN_DE_BENEFICIER}</Typography>
                <ul>
                    {getSubscriptionRoleName(subscription) === RoleNames.PM_PROFESSIONNEL
                        ? PM_DOCUMENTS_LIST.map(renderDocument)
                        : PP_DOCUMENTS_LIST.map(renderDocument)}
                </ul>
                {subscription?.role?.name === RoleNames.PP_PROFESSIONNEL && (
                    <Typography gutterBottom>{texts.NIF_REQUIRED}</Typography>
                )}
                <Typography gutterBottom>
                    {subscription?.role?.name === RoleNames.PP_PROFESSIONNEL
                        ? texts.SOUSCRIPTION_PRENDRA
                        : texts.SOUSCRIPTION_PRENDRA_PM}
                </Typography>
                <br></br>
                <Typography gutterBottom>
                    {subscription?.role?.name === RoleNames.PP_PROFESSIONNEL
                        ? texts.SIGNATURE_ELECTRONIQUE
                        : texts.SIGNATURE_NUMERIQUE}
                </Typography>
                <br></br>
                <Typography gutterBottom>{texts.CONFIRMATION_DE_VOTRE_SOUSCRIPTION}</Typography>
                <br></br>
            </TunnelBox>
            <SubmitButton
                onClick={isResubmit && hasStatusOk ? handleNextStep : handleSubmit}
                loading={submitLoader}
                disabled={submitLoader}
                text={texts.SUIVANT}
            />
        </TunnelStep>
    );
};

export default PerformancePedagogicStep;
